import React from "react"
import { RichText } from "prismic-reactjs"
import styled from "@emotion/styled"
import { Global } from "@emotion/core"
import globalStyles from "styles/global"
import typeStyles from "styles/typography"

const MaintenanceContainer = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;

  & h1 {
    margin: 1em 0;
  }

  & h3 {
    margin: 0;
    margin-top: 32px;
  }

  & p {
    margin-top: 32px;
    text-align: center;
    max-width: 400px;
  }

  & p:last-child {
    margin-bottom: 32px;
  }
`

const MaintenanceSection = ({ data }) => {
  return (
    <MaintenanceContainer>
      <Global styles={[globalStyles, typeStyles]} />
      <h3>Johannes Schön</h3>
      {RichText.render(data.maintenance_title)}
      {data.maintenance_banner && (
        <img src={data.maintenance_banner.url} alt="maintenance banner" />
      )}
      {RichText.render(data.maintenance_text)}
    </MaintenanceContainer>
  )
}

export default MaintenanceSection
